import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  getCities,
  getCountries,
  getDistricts,
  getStates,
  getUniversities,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import HttpClientXml from "../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";
import { createSlug } from "../../utils/Helper";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

const AddCollegeUniversity = () => {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [fetchDistrictsLoading, setFetchDistrictsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [fetchCitiesLoading, setFetchCitiesLoading] = useState(false);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);
  const fileBrouchureInputRef = useRef(null);
  const filePhotoInputRef = useRef(null);
  const [uploadingBrouchure, setUploadingBrouchure] = useState(false)
  const [uploadingPhoto, setUploadingPhoto] = useState(false)

  




  const initialValues = {
    type: "College",
    parentUniversity: "",
    name: "",
    shortDescription: "",
    longDescription: "",
    stateId: "",
    districtId: "",
    cityId: "",
    address: "",
    pinCode: "",
    estd: "",
    institutionType: "",
    countryId: "",
    isAbroad: false,
    collegeBrouchure: "",
    collegePhoto: "",
    seoFriendlyName:""
  }
  const [createCollegeObject, setCreateCollegeObject] = useState(initialValues);
  const [createCollegeLoading, setCreateCollegeLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchCities = async (district) => {
    try {
      setFetchCitiesLoading(true);
      const res = await getCities();
      console.log("fetched Cities", res?.data);
      if (res?.status) {
        setCities(res?.data.filter(item => item.district._id === district));
        setFetchCitiesLoading(false);
      } else {
        toast.error("Error while Fetching Cities Data");
        setFetchCitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Cities Data");
      console.error("Error fetching Districts:", error);
      setFetchCitiesLoading(false);
    }
  };

  const fetchDistricts = async (state) => {
    try {
      setFetchDistrictsLoading(true);
      const res = await getDistricts();
      console.log("fetched districts", res?.data);
      if (res?.status) {
        setDistricts(res?.data.filter(item => item.state._id === state));
        setFetchDistrictsLoading(false);
      } else {
        toast.error("Error while Fetching Districts Data");
        setFetchDistrictsLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Districts Data");
      console.error("Error fetching Districts:", error);
      setFetchDistrictsLoading(false);
    }
  };

  const fetchStates = async (country) => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data.filter(item => item.country._id === country));
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries()
    // fetchStates();
    // fetchDistricts();
    // fetchCities();
    fetchUniversities();
  }, []);



  const handleCreateCollege = async (e) => {
    e?.preventDefault();
    if (
      !createCollegeObject?.type ||
      !createCollegeObject?.parentUniversity ||
      !createCollegeObject?.stateId ||
      !createCollegeObject?.cityId ||
      !createCollegeObject?.name ||
      !createCollegeObject?.address ||
      !createCollegeObject?.districtId ||
      !createCollegeObject?.institutionType ||
      !createCollegeObject?.estd ||
      !createCollegeObject?.longDescription ||
      !createCollegeObject?.shortDescription ||
      !createCollegeObject?.pinCode
    ) {
      toast.error("Please Enter All Fields");
      return;
    }
    const formData = {...createCollegeObject,seoFriendlyName:createSlug(createCollegeObject?.name)}
    // console.log("GHU204",formData);
    // return
    try {
      setCreateCollegeLoading(true);
      const res = await addCollege(formData);
      console.log("College Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setCreateCollegeObject(initialValues)
        setCreateCollegeLoading(false);
        navigate("/college-university-overview", {
          state: { college: res?.data?._id }
        });
      } else {
        toast.error(res?.message);
        setCreateCollegeLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setCreateCollegeLoading(false);
    }
  };

  let a = false;
  let b = false;

  const handleBrouchureUpload = async (e) => {
    e.preventDefault()
    setUploadingBrouchure(true)
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("VFR235", res);

      if (res?.image) {
        setCreateCollegeObject({ ...createCollegeObject, collegeBrouchure: res.image })
        toast.success("Brouchure uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploadingBrouchure(false)
      fileBrouchureInputRef.current.value = null;
    }
  };

  const handlePhotoUpload = async (e) => {
    e.preventDefault()
    setUploadingPhoto(true)
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("VFR258", res);

      if (res?.image) {
        setCreateCollegeObject({ ...createCollegeObject, collegePhoto: res.image })
        toast.success("Photo uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploadingPhoto(false)
      filePhotoInputRef.current.value = null;
    }
  };

  // createCollegeObject?.countryId
  useEffect(() => {
    fetchStates(createCollegeObject?.countryId)
    setCreateCollegeObject({ ...createCollegeObject, stateId: "", districtId: "", cityId: "" })
  }, [createCollegeObject?.countryId])

  useEffect(() => {
    fetchDistricts(createCollegeObject?.stateId)
    setCreateCollegeObject({ ...createCollegeObject, districtId: "", cityId: "" })
  }, [createCollegeObject?.stateId])

  useEffect(() => {
    fetchCities(createCollegeObject?.districtId)
    setCreateCollegeObject({ ...createCollegeObject, cityId: "" })
  }, [createCollegeObject?.districtId])

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Add College or University
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleCreateCollege(e);
              }}
            >
              <div className="row d-flex justify-content-center">
                <div className="col-md-2 mt-3">
                  <label htmlFor="name">
                    Choose Type<span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "30px", // spacing between radio options
                      alignItems: "center",
                      marginTop: "8px"
                    }}
                  >
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="college"
                        value="College"
                        checked={createCollegeObject?.type === "College"}
                        onChange={(e) =>
                          setCreateCollegeObject((prev) => ({
                            ...prev,
                            type: e?.target?.value,
                          }))
                        }
                      />
                      College
                    </label>

                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="college"
                        value="University"
                        checked={createCollegeObject?.type === "University"}
                        onChange={(e) =>
                          setCreateCollegeObject((prev) => ({
                            ...prev,
                            type: e?.target?.value,
                          }))
                        }
                      />
                      University
                    </label>
                  </div>
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="name">
                    Choose <span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "30px",
                      alignItems: "center",
                      marginTop: "8px",
                    }}
                  >
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="govt"
                        value="Private"
                        checked={createCollegeObject?.institutionType === "Private"}
                        onChange={(e) =>
                          setCreateCollegeObject((prev) => ({
                            ...prev,
                            institutionType: e.target.value,
                          }))
                        }
                      />
                      Private
                    </label>

                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="govt"
                        value="Government"
                        checked={createCollegeObject?.institutionType === "Government"}
                        onChange={(e) =>
                          setCreateCollegeObject((prev) => ({
                            ...prev,
                            institutionType: e.target.value,
                          }))
                        }
                      />
                      Government
                    </label>
                  </div>
                </div>
                <div className="col-md-2 mt-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="isAbroad"
                      className="form-check-input"
                      checked={createCollegeObject?.isAbroad || false}
                      onChange={(e) => {
                        setCreateCollegeObject((prev) => ({
                          ...prev,
                          isAbroad: e.target.checked,
                        }));
                      }}
                    />
                    <label htmlFor="isAbroad" className="form-check-label">
                      Abroad
                    </label>
                  </div>
                </div>

                <div
                  className="col-md-6 mt-3"
                // style={{
                //   display:
                //     createCollegeObject?.type === "College" ? "" : "none",
                // }}
                >
                  <label htmlFor="name">
                    University Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        parentUniversity: e?.target?.value,
                      }));
                    }}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select University --------
                    </option>
                    {fetchUniversitiesLoading ? (
                      <option>Loading...</option>
                    ) : universities?.length === 0 ? (
                      <option>No University Found</option>
                    ) : (
                      universities.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
                <div className="col-md-10 mt-3">
                  <label htmlFor="name">
                    Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.name}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        name: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter Name"
                    required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="name">
                    ESTD<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.estd}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        estd: Number(e?.target?.value),
                      }));
                    }}
                    placeholder="Establishment Year"
                    required
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Short Description<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.shortDescription}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        shortDescription: e?.target?.value,
                      }));
                    }}
                    placeholder="Short Description"
                    required
                  />
                </div>
                <div
                  className="col-md-12 mt-3"
                  style={{ marginBottom: "-15px" }}
                >
                  <label style={{ fontSize: "24px", fontWeight: "600" }}>
                    Location
                  </label>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Country<span className="text-danger">*</span>
                  </label>
                  <select
                    required
                    className="form-control"
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        countryId: e?.target?.value,
                      }));
                    }}
                    value={createCollegeObject?.countryId}
                  >
                    <option value="">-------- Select Country --------</option>
                    {fetchCountriesLoading ? (
                      <option>Loading...</option>
                    ) : countries?.length === 0 ? (
                      <option disabled>No Country Found</option>
                    ) : (
                      countries?.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.countryName}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    State Name<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        stateId: e?.target?.value,
                      }));
                    }}
                  >
                    <option value="">-------- Select State --------</option>
                    {fetchStatesLoading ? (
                      <option>Loading...</option>
                    ) : states?.length === 0 ? (
                      <option disabled>No State Found</option>
                    ) : (
                      states?.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.stateName}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    District Name<span className="text-danger">*</span>
                  </label>
                  <select
                    disabled={!createCollegeObject?.stateId}
                    className="form-control"
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        districtId: e?.target?.value,
                      }));
                    }}
                  >
                    <option value="">-------- Select District --------</option>
                    {fetchDistrictsLoading ? (
                      <option>Loading...</option>
                    ) : districts?.length === 0 ? (
                      <option disabled>No District Found</option>
                    ) : (
                      districts?.map((e, i) => {
                        if (e?.state?._id === createCollegeObject?.stateId) {
                          a = true;
                          return (
                            <option key={i} value={e?._id}>
                              {e?.districtName}
                            </option>
                          );
                        }
                      })
                    )}
                    {!a && <option disabled>No District found</option>}
                  </select>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    City Name<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    disabled={!createCollegeObject?.districtId}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        cityId: e?.target?.value,
                      }));
                    }}
                  >
                    <option value="">-------- Select City --------</option>
                    {fetchCitiesLoading ? (
                      <option>Loading...</option>
                    ) : cities?.length === 0 ? (
                      <option disabled>No City Found</option>
                    ) : (
                      cities?.map((e, i) => {
                        if (
                          e?.district?._id === createCollegeObject?.districtId
                        ) {
                          b = true;
                          return (
                            <option key={i} value={e?._id}>
                              {e?.cityName}
                            </option>
                          );
                        }
                      })
                    )}
                    {!b && <option disabled>No City Found</option>}
                  </select>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Address<span className="text-danger">*</span>
                  </label>
                  <textarea
                    style={{ resize: "none" }}
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.address}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        address: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter Address"
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    PIN Code<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.pinCode}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        pinCode: Number(e?.target?.value),
                      }));
                    }}
                    placeholder="Enter PIN"
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="Brochure">
                    {uploadingBrouchure && "Uploading "}Brochure{/*<span className="text-danger">*</span> */}
                  </label>
                  {!uploadingBrouchure && createCollegeObject?.collegeBrouchure && (
                    <>
                      {/* <img
                      src={formData?.brochure}
                      alt="Brochure Preview"
                      style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                    /> */}
                      <a href={createCollegeObject?.collegeBrouchure} target="_blank"
                        style={{ marginLeft: "10px" }}
                      >
                        {
                          createCollegeObject?.collegeBrouchure.split('.').pop().toLowerCase() === "pdf" ? <i className="fas fa-2x fa-file-pdf" /> :
                            createCollegeObject?.collegeBrouchure.split('.').pop().toLowerCase() === "doc" || createCollegeObject?.collegeBrouchure.split('.').pop().toLowerCase() === "docx" && <i className="fas fa-2x fa-file-word" />
                        }
                      </a>
                    </>
                  )}
                  <input
                    type="file"
                    ref={fileBrouchureInputRef}
                    className="form-control"
                    onChange={handleBrouchureUpload}
                    // accept="image/*,.pdf,.doc,.docx"
                    accept=".pdf,.doc,.docx"
                  // required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="Brochure">
                    {uploadingPhoto && "Uploading "}Photo{/*<span className="text-danger">*</span> */}
                  </label>
                  {!uploadingPhoto && createCollegeObject?.collegePhoto && (
                    <>
                      <img
                        src={createCollegeObject?.collegePhoto}
                        alt="Photo Preview"
                        style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                      />
                    </>
                  )}
                  <input
                    type="file"
                    ref={filePhotoInputRef}
                    className="form-control"
                    onChange={handlePhotoUpload}
                    accept="image/*"
                  // required
                  />
                </div>

                {/* <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Long Description<span className="text-danger">*</span>
                  </label>
                  <textarea
                    style={{ resize: "none" }}
                    type="text"
                    id="name"
                    className="form-control"
                    value={createCollegeObject?.longDescription}
                    onChange={(e) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        longDescription: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter Description"
                    required
                  />
                </div> */}
                <div className="col-md-12 mt-3">
                  <label htmlFor="longDescription">
                    Long Description<span className="text-danger">*</span>
                  </label>
                  <ReactQuill
                    modules={modules}
                    id="longDescription"
                    theme="snow"
                    value={createCollegeObject?.longDescription || ""}
                    onChange={(value) => {
                      setCreateCollegeObject((prev) => ({
                        ...prev,
                        longDescription: value,
                      }));
                    }}
                    placeholder="Enter Long Description"
                    style={{
                      height: "150px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                      fontSize: "1rem"
                    }}
                  />
                </div>

              </div>
              <div className=" d-flex justify-content-end">
                <button
                  disabled={createCollegeLoading}
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                >
                  {createCollegeLoading
                    ? "Loading..."
                    : "Add"
                    // : "Next"
                  }
                </button>
              </div>
            </form>
          </section>
        </div>
      </div >
    </>
  );
};

export default AddCollegeUniversity;
